var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clock"}},[_c('label',{staticClass:"time"},[_vm._v(_vm._s(_vm.title)+": ")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.formattedTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }